<section class="calendar-widget">
  <div
    class="view-tabs"
    role="tablist"
    [attr.aria-label]="'translations.dashboard.calendarWidget.viewsAria' | translate">
    <button
      type="button"
      role="tab"
      class="view-tab"
      [class.active]="activeView === 'upcoming'"
      [attr.aria-selected]="activeView === 'upcoming'"
      (click)="setActiveView('upcoming')">
      {{ 'translations.dashboard.calendarWidget.upcoming' | translate }}
    </button>
    <button
      type="button"
      role="tab"
      class="view-tab"
      [class.active]="activeView === 'scheduled'"
      [attr.aria-selected]="activeView === 'scheduled'"
      (click)="setActiveView('scheduled')">
      {{ 'translations.dashboard.calendarWidget.scheduled' | translate }}
      <span class="view-tab-count" *ngIf="scheduledCount">
        ({{ scheduledCount }})
      </span>
    </button>
  </div>
  <div class="widget-container">
    <div class="calendar-header" *ngIf="activeView === 'upcoming'">
      <button
        type="button"
        class="month-btn"
        [attr.aria-label]="
          'translations.dashboard.calendarWidget.previousMonth' | translate
        "
        (click)="changeMonth(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        type="button"
        class="calendar-title"
        (click)="goToToday()"
        [attr.aria-label]="
          'translations.dashboard.calendarWidget.showToday'
            | translate : { date: headerDateLabel }
        ">
        {{ headerDateLabel }}
      </button>
      <button
        type="button"
        class="month-btn"
        [attr.aria-label]="
          'translations.dashboard.calendarWidget.nextMonth' | translate
        "
        (click)="changeMonth(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  
    <app-pill-tabs
      *ngIf="activeView === 'upcoming'"
      class="calendar-filter-tabs"
      [tabs]="filterTabs"
      [activeIndex]="activeFilterIndex"
      (activeIndexChange)="onFilterTabChange($event)"
      [ariaLabel]="
        'translations.dashboard.calendarWidget.filtersAria' | translate
      "
      [columns]="filters.length"></app-pill-tabs>
  
    <div class="calendar-content" *ngIf="!isLoading; else calendarState">
      <div class="empty-agenda calendar-error-state" *ngIf="showFullErrorState">
        <mat-icon>cloud_off</mat-icon>
        <span>{{
          'translations.dashboard.calendarWidget.loadError' | translate
        }}</span>
        <button type="button" class="retry-btn" (click)="retryRequested.emit()">
          {{ 'translations.dashboard.calendarWidget.retry' | translate }}
        </button>
      </div>
  
      <div class="calendar-error-state calendar-error-state--inline" *ngIf="showInlineErrorState">
        <mat-icon>cloud_off</mat-icon>
        <span>{{
          'translations.dashboard.calendarWidget.loadError' | translate
        }}</span>
        <button type="button" class="retry-btn" (click)="retryRequested.emit()">
          {{ 'translations.dashboard.calendarWidget.retry' | translate }}
        </button>
      </div>
  
      <div class="month-panel" #monthPanel *ngIf="activeView === 'upcoming'">
        <div class="week-grid">
          <span *ngFor="let day of weekDays">{{ day }}</span>
        </div>
  
        <div class="day-grid">
          <button
            type="button"
            *ngFor="let day of calendarDays"
            class="day-cell"
            [class.muted]="!day.isCurrentMonth"
            [class.today]="day.isToday"
            [class.selected]="day.isSelected"
            [class.has-items]="
              day.hasEvents || day.hasNews || day.hasTasks || day.hasUpdates
            "
            (click)="selectDate(day)">
            <span class="day-number">{{ day.dayNumber }}</span>
          </button>
        </div>
      </div>
  
      <div
        class="agenda-panel"
        [class.agenda-panel--scheduled]="activeView === 'scheduled'"
        [class.scroll-enabled]="hasScrollableAgenda">
        <div class="agenda-header" *ngIf="activeView === 'upcoming' && selectedDate">
          <div>
            <span class="eyebrow">{{
              'translations.dashboard.calendarWidget.selectedDay' | translate
            }}</span>
            <div class="agenda-heading">
              <h3>{{ selectedDateLabel }}</h3>
              <button
                type="button"
                class="clear-selection-btn"
                (click)="clearSelection()"
                [attr.aria-label]="
                  'translations.dashboard.calendarWidget.clearSelection'
                    | translate
                ">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <span class="agenda-total">{{ selectedItems.length }}</span>
        </div>
  
        <div class="agenda-list-shell">
          <div
            class="agenda-list"
            #agendaList
            *ngIf="visibleAgendaItems.length; else emptyAgenda"
            (scroll)="onAgendaScroll()">
            <button
              type="button"
              class="agenda-item"
              *ngFor="let item of visibleAgendaItems"
              (click)="openItem(item)">
              <span class="item-icon" aria-hidden="true">{{
                item.assigneeInitials
              }}</span>
              <span class="item-time">
                <span class="item-badge">{{ item.badge }}</span>
                <span>{{ formatTime(item) }}</span>
              </span>
              <span class="item-title">{{ item.title }}</span>
              <span
                class="item-action"
                [class.item-action--urgent]="isUrgentItem(item)">
                {{ itemActionLabel(item) }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #calendarState>
  <div class="calendar-loader">
    <div class="loader-month" *ngIf="activeView === 'upcoming'">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{ width: '180px', height: '22px' }"></ngx-skeleton-loader>
      <div class="loader-grid">
        <ngx-skeleton-loader
          *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]"
          count="1"
          appearance="line"
          [theme]="{ width: '32px', height: '32px', margin: '0' }">
        </ngx-skeleton-loader>
      </div>
    </div>
    <div class="loader-list">
      <ngx-skeleton-loader
        *ngFor="let item of [1, 2, 3]"
        count="1"
        appearance="line"
        [theme]="{ width: '100%', height: '48px', margin: '0 0 8px' }">
      </ngx-skeleton-loader>
    </div>
  </div>
</ng-template>

<ng-template #emptyAgenda>
  <div class="empty-agenda">
    <mat-icon>event_busy</mat-icon>
    <span>{{ emptyAgendaLabel }}</span>
  </div>
</ng-template>
